import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import CannyRouter from 'common/core/CannyRouter';

import JobsRoutes from './JobsRoutes';

import 'css/jobs.scss';

class JobsApp extends Component {
  render() {
    const { history } = this.props;
    return <CannyRouter history={history} routes={JobsRoutes} />;
  }
}

export default hot(JobsApp);
